import { render } from "./VersionMismatchBanner.3.vue?vue&type=template&id=6403fe63&ts=true"
import script from "./VersionMismatchBanner.3.vue?vue&type=script&lang=ts"
export * from "./VersionMismatchBanner.3.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__